import { useLocale, type Locale } from '../i18n';
import { getToken, updatePreferredLanguage } from '../services/api';

const LOCALE_OPTIONS: { value: Locale; label: string }[] = [
  { value: 'pt-BR', label: 'Português (Brasil)' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'zh-CN', label: '中文 (简体)' },
  { value: 'fr', label: 'Français' },
  { value: 'it', label: 'Italiano' },
];

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();

  async function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const next = e.target.value as Locale;
    setLocale(next);
    // Bug #2: persist preference to backend for logged-in users.
    // Non-logged-in users keep using localStorage only (setLocale above).
    if (getToken()) {
      try {
        await updatePreferredLanguage(next);
      } catch {
        // Silently ignore — localStorage already has the preference,
        // and the user will see the selected language regardless.
      }
    }
  }

  return (
    <div className="relative flex items-center">
      <span
        className="pointer-events-none absolute left-2 text-brand-500"
        aria-hidden="true"
      >
        {/* globe icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      </span>
      <select
        value={locale}
        onChange={handleChange}
        aria-label="Selecionar idioma"
        className="appearance-none rounded-md border border-brand-200 bg-white py-1.5 pl-8 pr-7 text-sm text-brand-700 hover:border-brand-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
      >
        {LOCALE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <span
        className="pointer-events-none absolute right-2 text-brand-500"
        aria-hidden="true"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-3 w-3"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </span>
    </div>
  );
}
